import MobileUserItem from "./MobileUserItem";
import UserRow from "./Row";
import RoleBadge from "./Row/RoleBadge";

const UsersTable = ({ users, loading, onEdit, onDelete }) => {

    if (loading) {
        return (
            <div className="flex justify-center py-20">
                <div className="animate-spin w-10 h-10 border-4 border-purple-400 border-t-transparent rounded-full"/>
            </div>
        );
    }

    return (
        <div className="bg-white rounded-xl shadow overflow-hidden">

            {/* Desktop Table */}
            <div className="hidden md:block">

                <table className="w-full text-sm">

                    <thead className="bg-gray-50 border-b">
                        <tr className="text-gray-600">
                            <th className="p-4 text-right font-medium">کاربر</th>
                            <th className="p-4 text-right font-medium">شماره</th>
                            <th className="p-4 text-right font-medium">نقش</th>
                            <th className="p-4 text-right font-medium">عملیات</th>
                        </tr>
                    </thead>

                    <tbody className="divide-y">

                        {users.map((u) => (
                            <UserRow
                                key={u._id}
                                user={u}
                                onEdit={onEdit}
                                onDelete={onDelete}
                            />
                        ))}

                    </tbody>

                </table>

            </div>


            {/* Mobile Cards */}
            <div className="md:hidden divide-y">
                
                {users.map((u) => (
                    
                    <MobileUserItem
                        key={u._id}
                        user={u}
                        onEdit={onEdit}
                        onDelete={onDelete}
                    />

                ))}

            </div>

        </div>
    );
};

export default UsersTable;
